import { render, staticRenderFns } from "./AppCredit.vue?vue&type=template&id=1178b89e&scoped=true&"
import script from "./AppCredit.vue?vue&type=script&lang=js&"
export * from "./AppCredit.vue?vue&type=script&lang=js&"
import style0 from "./AppCredit.vue?vue&type=style&index=0&id=1178b89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1178b89e",
  null
  
)

export default component.exports